import React from 'react'
import { Box, Flex, Text } from 'rebass/styled-components'
import styled from 'styled-components'
import renderHTML from 'react-render-html'
import MediaRender from '../general/MediaRender'
import { stripHtmlTags } from '../../helpers/Functions'

const TestimonialContainer = styled(Flex)`
    align-items: flex-start;
    justify-content: flex-start;
    margin: ${(props) => props.theme.space.xxl} auto;
    max-width: 1200px;
    padding: ${(props) => props.theme.space.xxl} ${(props) => props.theme.space.md} 0;
    position: relative;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        margin: ${(props) => props.theme.space.xl} auto;
        padding: ${(props) => props.theme.space.xl} ${(props) => props.theme.space[4]} 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        flex-direction: column;
        padding: ${(props) => props.theme.space.xl} 0 0;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
        margin: ${(props) => props.theme.space.lg} auto;
        padding-top: ${(props) => props.theme.space.lg};
    }
`
const Ruler = styled(Box)`
    background-color: ${(props) => props.theme.colors.black};
    border: none;
    height: 1px;
    left: ${(props) => props.theme.space.md};
    position: absolute;
    top: 0;
    width: calc(100% - 60px);

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        left: ${(props) => props.theme.space[4]};
        width: calc(100% - 48px);
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        left: ${(props) => props.theme.space.sm};
        width: calc(100% - 36px);
    }
`

const Column = styled(Box)`
    align-self: stretch;
    order: 0;
    position: relative; 
    flex-grow: 1;
    flex-basis: 50%;

    &.left {
        padding-right: ${(props) => props.theme.space.lg};
    }
    &.right {
        padding-left: ${(props) => props.theme.space.lg};
    }
    &.border {
        border-color: ${(props) => props.theme.colors.black};
        border-style: solid;
        border-width: 0 0 0 1px;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        &.left {
            padding-right: ${(props) => props.theme.space[4]};
        }
        &.right {
            padding-left: ${(props) => props.theme.space[4]};
        }
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        flex-basis: 100%;
        &.left {
            padding-left: ${(props) => props.theme.space.sm};
            padding-right: ${(props) => props.theme.space.sm};
        }
        &.right {
            padding-left: ${(props) => props.theme.space.sm};
            padding-right: ${(props) => props.theme.space.sm};
            padding-top: ${(props) => props.theme.space.lg};
        }
        &.border {
            border-width: 0;
        }
    }

    @media (max-width: ${(props) => props.theme.breakpoints.xxs}) {
        flex-basis: 100%;
        &.left.media {
            padding-left: 0;
            padding-right: 0;
        }
    }
`

const Name = styled(Text)`
    font-family: ${(props) => props.theme.fonts.heading};
    font-size: ${(props) => props.theme.fontSizes.xxl};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    letter-spacing: 2px;
    line-height: 30px;
    margin-top: ${(props) => props.theme.space.md};
    padding-bottom: 0;
`

const Title = styled(Text)`
    font-style: italic;
    line-height: 18px;
    padding-top: ${(props) => props.theme.space.xxs};

    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
        font-style: normal;
    }
`

const TestimonialTwoCol = ({ options, type }) => {
    let col1 = null
    let rightCol = {}
    switch (type) {
    case 'media':
        col1 = <Column className="left media">
            <MediaRender file={options.media.set[0]} alt={options.alt} />
        </Column>
        rightCol = options
        break
    default:
        const sanitisedLeftContent = stripHtmlTags(options.left.content)
        col1 = <Column className="left">
            <Text variant="quote">{renderHTML(sanitisedLeftContent || '')}</Text>
            <Name>{renderHTML(options.left.author || '')}</Name>
            <Text>{renderHTML(options.left.authorTitle || '')}</Text>
        </Column>
        rightCol = options.right
    }
    const sanitisedRightContent = stripHtmlTags(rightCol.content)
    return (
        <TestimonialContainer>
            <Ruler as="hr" />
            {col1}
            <Column className={`${(type !== 'media') ? 'border right' : 'right'}`}>
                <Text variant="quote">{renderHTML(sanitisedRightContent || '')}</Text>
                <Name>{renderHTML(rightCol.author || '')}</Name>
                <Title>{renderHTML(rightCol.authorTitle || '')}</Title>
            </Column>
        </TestimonialContainer>
    )
}

export default TestimonialTwoCol
